import React from "react";
import styles from "./loading.module.css";

const LoadingPage = () => {
  return (
    <div className="inset-0 bg-black/10 backdrop-blur flex justify-center items-center absolute z-50">
      <div className={styles["spinner"]}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingPage;
